// extracted by mini-css-extract-plugin
export default {"msgM":"_4715654517"};